import { cn } from "@/lib/utils";

/** Las iniciales de las dos primeras palabras de la razón social: "BETA KONCRET SAC" → "BK". */
function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

/** El avatar cuadrado de una empresa en el listado y en la barra lateral. */
export function CompanyInitials({ name, className }: { name: string; className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "flex size-10 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-sm font-extrabold text-blue-700 dark:bg-blue-950/40 dark:text-blue-300",
        className,
      )}
    >
      {initialsOf(name)}
    </div>
  );
}
